import routes from '../api-routes';

export default (value) => `${routes.ROOT_URL}/${value}`;
